import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import { useStyles } from "../../theme/style";

const Modal = ({
  headerMessage = "Are you sure you want to register?",
  onCancel,
  handleSubmit,
  cancelButtonText = "",
  submitButtonText = "Submit",
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const handleClickOutside = (event) => {
    if (event.target === event.currentTarget) {
      onCancel();
    }
  };

  return (
    <Box
      className="modal-container"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 100,
      }}
    >
      <Box
        style={{
          backgroundColor: theme.palette.cards.background,
          padding: theme.size[30],
          borderRadius: theme.size[5],
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          color: theme.palette.cards.heading,
          minWidth: "30%",
        }}
        onClick={handleClickOutside}
      >
        <Typography
          sx={{
            fontSize: theme.size[14],
          }}
        >
          {headerMessage}
        </Typography>
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: theme.sizeRem[0.5],
            paddingTop: theme.size[20],
          }}
        >
          {cancelButtonText && (
            <Button className={classes.outlinedButton} onClick={onCancel}>
              {cancelButtonText}
            </Button>
          )}
          <Button className={classes.filledButton} onClick={handleSubmit}>
            {submitButtonText}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Modal;
